import { Link, rem, Text } from "@certn/cascadia";
import { Divider } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { IdentityVerificationForm } from "./components/IdentityVerificationForm";

const DBS_GUIDELINES_URL =
  "https://www.gov.uk/government/publications/dbs-identity-checking-guidelines/id-checking-guidelines-for-standardenhanced-dbs-check-applications-from-22-april-2025";

interface Props {
  caseId: string;
  hasNotManuallyVerified?: boolean;
  updateTabAndCaseDetails: () => void;
}

export function IdentityVerification(props: Props) {
  const { t } = useTranslation();
  const { caseId, hasNotManuallyVerified, updateTabAndCaseDetails } = props;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Text style="global/title-small">{t("Identity Verification")}</Text>
        <Text style="global/body-secondary" color="text-weak">
          {t(
            "Biometric identity verification could not confirm this applicant's identity. Complete the form below to verify the applicant's identity manually using the DBS identity checking process."
          )}{" "}
          <Link
            linkStyle="monochrome"
            textStyle="global/body-secondary-link"
            textColor="text-weak"
            href={DBS_GUIDELINES_URL}
            testID="idv-header-learn-more-link"
            isNewTab
          >
            {t("Learn more")}
          </Link>
        </Text>
      </div>
      <Divider />
      <IdentityVerificationForm
        caseId={caseId}
        hasNotManuallyVerified={hasNotManuallyVerified}
        updateTabAndCaseDetails={updateTabAndCaseDetails}
      />
    </div>
  );
}

const styles = {
  container: css({
    display: "flex",
    flexDirection: "column",
    gap: rem("space-6"),
    paddingRight: rem("space-5"),
    paddingLeft: rem("space-5"),
    paddingTop: rem("space-6"),
    paddingBottom: rem("space-6"),
  }),

  header: css({
    display: "flex",
    flexDirection: "column",
    gap: rem("space-3"),
  }),
};
